import Keycloak from 'keycloak-js'

// eslint-disable-next-line no-undef
// @ts-ignore
export default new Keycloak(`/keycloak/keycloak.${process.env.REACT_APP_NODE_ENV}.json`)
